import { render, staticRenderFns } from "./WalletDialog.vue?vue&type=template&id=d582b05e"
import script from "./WalletDialog.vue?vue&type=script&lang=js"
export * from "./WalletDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports